import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ExitStrategy, ExitStrategyState } from '../../types/exitStrategy';

const initialState: ExitStrategyState = {
  strategies: {},
  isLoading: false,
  error: null,
  lastGenerated: null,
};

const exitStrategySlice = createSlice({
  name: 'exitStrategy',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },

    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },

    addExitStrategy: (state, action: PayloadAction<ExitStrategy>) => {
      const strategy = action.payload;
      state.strategies[strategy.conversationStarterId] = strategy;
      state.lastGenerated = strategy.createdAt;
      state.isLoading = false;
      state.error = null;
    },

    updateExitStrategy: (state, action: PayloadAction<ExitStrategy>) => {
      const strategy = action.payload;
      if (state.strategies[strategy.conversationStarterId]) {
        state.strategies[strategy.conversationStarterId] = {
          ...strategy,
          updatedAt: new Date().toISOString()
        };
      }
    },

    removeExitStrategy: (state, action: PayloadAction<string>) => {
      const conversationStarterId = action.payload;
      delete state.strategies[conversationStarterId];
    },

    clearExitStrategies: (state) => {
      state.strategies = {};
      state.lastGenerated = null;
      state.error = null;
    },

    clearError: (state) => {
      state.error = null;
    }
  },
});

export const {
  setLoading,
  setError,
  addExitStrategy,
  updateExitStrategy,
  removeExitStrategy,
  clearExitStrategies,
  clearError
} = exitStrategySlice.actions;

export default exitStrategySlice.reducer;

// Selectors
export const selectExitStrategies = (state: { exitStrategy: ExitStrategyState }) => 
  state.exitStrategy.strategies;

export const selectExitStrategyByConversationId = (state: { exitStrategy: ExitStrategyState }, conversationId: string) => 
  state.exitStrategy.strategies[conversationId];

export const selectExitStrategyLoading = (state: { exitStrategy: ExitStrategyState }) => 
  state.exitStrategy.isLoading;

export const selectExitStrategyError = (state: { exitStrategy: ExitStrategyState }) => 
  state.exitStrategy.error;

export const selectLastGenerated = (state: { exitStrategy: ExitStrategyState }) => 
  state.exitStrategy.lastGenerated;